import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkConditionsQueryKeys } from "./queryKeys"

export function useNetworkConditions(project, queryParameters, config = {}) {
    const url = "network_conditions/"

    const parameters = useExtendWithSubnetworks({
        project,
        ...queryParameters,
    }, API_MODULE_ROADWAY)
    const { enabled = true } = config
    const queryKey = networkConditionsQueryKeys["list"](parameters)

    return useRoadQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: !!project && enabled,
        },
    )
}